import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import { IAuthResponse } from '../../../app.common/modules/account/models';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { IPaginationStoreManagersFilter } from '../api';
import { RetailerService } from '../api/retailer.service';
import { StoreManager, StoreManagerAccountPagingResult } from '../core';
import { IStoreForShopingListItem, IStoreManagerAccountListItem, IStoreManagerColumnSet } from './models';

export class StoreManagerService {
    public static $inject = ['http', '$q', '$uibModal', 'retailerService', '$httpParamSerializer'];

    constructor(
        private http: HttpService,
        private $q: ng.IQService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private retailerService: RetailerService,
        private $httpParamSerializer: ng.IHttpParamSerializer,
    ) { }

    public getAccounts(filter: IPaginationStoreManagersFilter) {
        return this.http.get<StoreManagerAccountPagingResult>(this.retailerService.storeManagers(), { params: filter });
    }

    public isAccountAny(isActive: boolean) {
        return this.http.get<boolean>(this.retailerService.storeManagerAny(isActive));
    }

    public archiveAccount(ids: number[]) {
        return this.http.delete<void>(this.retailerService.storeManagerAccount(), { params: { id: ids } });
    }

    public restoreAccount(ids: number[]) {
        return this.http.post<void>(this.retailerService.storeManagerAccountRestore(), ids);
    }

    public createStaff(staff: StoreManager) {
        return this.http.post<number>(this.retailerService.storeManagerAccount(), staff);
    }

    public updateStaff(id: number, staff: StoreManager) {
        return this.http.put(this.retailerService.storeManagerAccount(id), staff);
    }

    public managerAccountEmailExist(email: string) {
        return this.http.get(this.retailerService.storeManagerAccountEmailExist(email));
    }

    public getColumnSort(name?: string, isAsc?: boolean): IStoreManagerColumnSet {
        return {
            column: name ? name : 'ID',
            order: 'ascending',
            asc: 'ascending',
            desc: 'descending',
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            // tslint:disable-next-line: no-shadowed-variable
            set(name: string, isAsc: boolean) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                } else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'ID';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort(list: any[], field: string, asc: boolean) {
                return asc ? _.sortBy(list, field) : _.sortBy(list, field).reverse();
            },
            isSelected(field: string) {
                return this.column === field;
            }
        };
    }

    public openAccountManager = (staff: IStoreManagerAccountListItem, places: IStoreForShopingListItem[]) => {
        return this.$uibModal.open({
            component: 'storeManagerAccount',
            resolve: {
                staff: () => staff,
                places: () => places
            },
            size: 'lg',
            windowClass: 'staffPopup',
            backdrop: 'static'
        }).result;
    }
}
angular
    .module('naut')
    .service('storeManagerService', StoreManagerService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/store-managers/storeManager.service.ts